import App from './components/App.svelte';
// import "../public/global.scss";

const app = new App({
	target: document.body
});

export default app;
